/**
 * Pure helpers for the order-chat feature.
 */
import type { OrderChatMessage } from "@entities/order";

/**
 * Merge REST history with the live WS overlay, de-duplicating by id and ordering by
 * ``id`` ascending. ``id`` is the DB auto-increment PK → strictly chronological, immune to
 * ``created_at`` string-format differences between the REST payload and the WS broadcast
 * (which previously mis-ordered live messages — they "jumped up" until a reload re-fetched
 * history).
 */
export function mergeMessages(
  history: readonly OrderChatMessage[],
  live: readonly OrderChatMessage[],
): readonly OrderChatMessage[] {
  const byId = new Map<number, OrderChatMessage>();
  for (const message of history) {
    byId.set(message.id, message);
  }
  for (const message of live) {
    if (!byId.has(message.id)) {
      byId.set(message.id, message);
    }
  }
  return [...byId.values()].sort((a, b) => a.id - b.id);
}
